import { ICopyable } from '../controls/common/icopyable';
import { IDisplayableItem } from './interfaces/displayable-item.interface';
import { IGroup } from './interfaces/group.interface';

export class Group implements ICopyable<Group>, IDisplayableItem {
    public id: string = null;
    public name: string = null;
    public paramsSetId: number = null;
    public parentGroupId: string = null;
    public roles: number[] = null;
    public isOrganizationRoot: boolean = false;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): Group {
        const instance = new Group();
        instance.id = this.id;
        instance.name = this.name;
        instance.paramsSetId = this.paramsSetId;
        instance.parentGroupId = this.parentGroupId;
        instance.roles = [...this.roles];
        instance.isOrganizationRoot = this.isOrganizationRoot;

        return instance;
    }

    public static createFormCopy(group: Group): IGroup {
        const instance = new Group();
        instance.id = group.id;
        instance.name = group.name;
        instance.parentGroupId = group.parentGroupId;
        instance.roles = [...group.roles];
        instance.isOrganizationRoot = group.isOrganizationRoot;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.paramsSetId = other.paramsSetId;
        this.parentGroupId = other.parentGroupId;
        this.roles = [...other.roles];
        this.isOrganizationRoot = other.isOrganizationRoot;
    }

    /**
     * Retourne une instance de Group à partir d'une instance de IGroup.
     * @param other : Instance de IGroup.
     * @returns : Instance de Group.
     */
    public static from(other: IGroup) {
        if (!!other) {
            const instance = new Group();

            instance.id = other.id;
            instance.name = other.name;
            instance.parentGroupId = other.parentGroupId;
            instance.roles = [...other.roles];
            instance.isOrganizationRoot = other.isOrganizationRoot;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de Group à partir d'un tableau d'instances de IGroup.
     * @param other : Tableau d'instances de IGroup.
     * @returns : Tableau d'instances de Group.
     */
    public static fromArray(others: IGroup[]) {
        if (!!others) {
            let groups: Group[] = [];

            others.forEach((x) => {
                const group = Group.from(x);
                groups.push(group);
            });

            return groups;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.name}`;
    }

    get displayName(): string {
        return `${this.name}`;
    }
}
